import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IMaskModule } from 'angular-imask';

import { SanitizeUrlPipe } from './utils/pipes/sanitizeurl.pipe';

import { ImageService } from './services/image.service';
import { WindowService } from './services/window-service';
import { ElasticDirective } from './directives/vraagcontrols/textarea/textarea.directive';
import { FileDropComponent } from './directives/file-drop/file-drop.component';

import { DatepickerDirective } from './directives/calendar/datepicker.directive';
import { DatepickerVanTotDirective } from './directives/calendar/datepickerVanTot.directive';
import { DateDirective } from './directives/calendar/date.directive';
import { ContactComponent } from './directives/contact/contact.component';
import { ErrorContainerComponent } from './directives/error-container/error-container.component';
import { FakeContentItemComponent } from './directives/fake-content-item/fake-content-item.component';
import { FakeContentSectionComponent } from './directives/fake-content-section/fake-content-section.component';
import { LoaderComponent } from './directives/loader/loader.component';
import { SelectieComponent } from './directives/selectie/selectie.component';
import { SharedTekstComponent } from './directives/sharedtekst/sharedtekst.component';
import { VerzekeringComponent } from './directives/verzekering/verzekering.component';

import { BedragComponent } from './directives/vraagcontrols/bedrag/bedrag.component';
import { BedragSummaryComponent } from './directives/vraagcontrols/bedrag-summary/bedrag-summary.component';
import { ContactGegevensComponent } from './directives/vraagcontrols/contact-gegevens/contact-gegevens.component';
import { ContactGegevensSummaryComponent } from './directives/vraagcontrols/contact-gegevens-summary/contact-gegevens-summary.component';
import { DatePickerComponent } from './directives/vraagcontrols/date-picker/date-picker.component';
import { DatePickerSummaryComponent } from './directives/vraagcontrols/date-picker-summary/date-picker-summary.component';
import { DateVanTotPickerComponent } from './directives/vraagcontrols/date-van-tot-picker/date-van-tot-picker.component';
import { DateVanTotPickerSummaryComponent } from './directives/vraagcontrols/date-van-tot-picker-summary/date-van-tot-picker-summary.component';
import { DecimalComponent } from './directives/vraagcontrols/decimal/decimal.component';
import { DecimalSummaryComponent } from './directives/vraagcontrols/decimal-summary/decimal-summary.component';
import { FailureComponent } from './directives/vraagcontrols/failure/failure.component';
import { IconComponent } from './directives/vraagcontrols/icon/icon.component';
import { InfoComponent } from './directives/vraagcontrols/info/info.component';
import { LabelComponent } from './directives/vraagcontrols/label/label.component';
import { ReferentieComponent } from './directives/vraagcontrols/referentie/referentie.component';
import { MobielSchadeMeldenComponent } from './directives/vraagcontrols/mobielschademelden/mobielschademelden.component';
import { MultiselectComponent } from './directives/vraagcontrols/multiselect/multiselect.component';
import { MultiselectSummaryComponent } from './directives/vraagcontrols/multiselect-summary/multiselect-summary.component';
import { MultiUploadComponent } from './directives/vraagcontrols/multiupload/multiupload.component';
import { MultiUploadSummaryComponent } from './directives/vraagcontrols/multiupload-summary/multiupload-summary.component';
import { NumberComponent } from './directives/vraagcontrols/number/number.component';
import { NumberSummaryComponent } from './directives/vraagcontrols/number-summary/number-summary.component';
import { TelefoonComponent } from './directives/vraagcontrols/telefoon/telefoon.component';
import { SelectieSummaryComponent } from './directives/vraagcontrols/selectie-summary/selectie-summary.component';
import { SingleChoiceWithFilterComponent } from './directives/vraagcontrols/single-choice-with-filter/single-choice-with-filter.component';
import { RadiobuttonListComponent } from './directives/vraagcontrols/radiobutton-list/radiobutton-list.component';
import { RadiobuttonListRepairComponent } from './directives/vraagcontrols/radiobutton-list-repair/radiobutton-list-repair.component';
import { RadiobuttonListRepairWithSearchComponent } from './directives/vraagcontrols/radiobutton-list-repair-with-search/radiobutton-list-repair-with-search.component';
import { RadiobuttonListSummaryComponent } from './directives/vraagcontrols/radiobutton-list-summary/radiobutton-list-summary.component';
// tslint:disable-next-line:max-line-length
import { RadiobuttonListWithDescriptionComponent } from './directives/vraagcontrols/radiobutton-list-with-description/radiobutton-list-with-description.component';
import { RuitherstellerComponent } from './directives/vraagcontrols/ruithersteller/ruithersteller.component';
import { StatusComponent } from './directives/vraagcontrols/status/status.component';
import { StatusDynamicComponent } from './directives/vraagcontrols/status-dynamic/status-dynamic.component';
import { SuccesComponent } from './directives/vraagcontrols/succes/succes.component';
import { SummaryComponent } from './directives/vraagcontrols/summary/summary.component';
import { TextareaComponent } from './directives/vraagcontrols/textarea/textarea.component';
import { TextareaSummaryComponent } from './directives/vraagcontrols/textarea-summary/textarea-summary.component';
import { TekstregelComponent } from './directives/vraagcontrols/tekstregel/tekstregel.component';
import { TekstregelSummaryComponent } from './directives/vraagcontrols/tekstregel-summary/tekstregel-summary.component';
import { TimePickerComponent } from './directives/vraagcontrols/time-picker/time-picker.component';
import { TimePickerSummaryComponent } from './directives/vraagcontrols/time-picker-summary/time-picker-summary.component';
import { UploadComponent } from './directives/vraagcontrols/upload/upload.component';
import { UploadSummaryComponent } from './directives/vraagcontrols/upload-summary/upload-summary.component';
import { WoonglasherstellerComponent } from './directives/vraagcontrols/woonglashersteller/woonglashersteller.component';
import { VraagboomSummaryGroupComponent } from './directives/vraagboom-summary-group/vraagboom-summary-group.component';
import { VraagControlComponent } from './directives/vraagcontrols/vraag-control/vraag-control.component';
import { VraagControlSummaryComponent } from './directives/vraagcontrols/vraag-control-summary/vraag-control-summary.component';
import { VragenboomComponent } from './directives/vragenboom/vragenboom.component';
import { NavigationService } from './services/navigation.service';
import { ChatConfigurationService } from './services/chat-configuration.service';
import { DataService } from './services/data.service';
import { RefreshSessionService } from './services/refresh-session.service';
import { CrosscuttingModule } from '@crosscutting/public_api';
import { RadiobuttonListComingDaysComponent } from './directives/vraagcontrols/radiobutton-list-coming-days/radiobutton-list-coming-days.component';
import { RadiobuttonListComingDaysSummaryComponent } from './directives/vraagcontrols/radiobutton-list-coming-days-summary/radiobutton-list-coming-days-summary.component';
import { ButtonSuccesComponent } from './directives/vraagcontrols/button-succes/button-succes.component';
import { SliderComponent } from './directives/slider/slider.component';
import { ProgressComponent } from './directives/progress/progress.component';
import { MultiselectDoorvragenComponent } from './directives/vraagcontrols/multiselect-doorvragen/multiselect-doorvragen.component';
import { MultilineTextComponent } from './directives/multiline-text/multiline-text.component';
import { MultiselectDoorvragenSummaryComponent } from './directives/vraagcontrols/multiselect-doorvragen-summary/multiselect-doorvragen-summary.component';
import { SliderSingleComponent } from './directives/vraagcontrols/slider-single/slider-single.component';
import { SliderSingleSummaryComponent } from './directives/vraagcontrols/slider-single-summary/slider-single-summary.component';

import { SvgAlertComponent } from './svg/alert/alert.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IMaskModule,
    ReactiveFormsModule,
    CrosscuttingModule.forRoot()
  ],
  declarations: [
    ElasticDirective,
    FileDropComponent,
    SanitizeUrlPipe,
    LoaderComponent,
    SharedTekstComponent,
    VerzekeringComponent,
    BedragComponent,
    BedragSummaryComponent,
    ButtonSuccesComponent,
    ContactComponent,
    ContactGegevensComponent,
    ContactGegevensSummaryComponent,
    DateDirective,
    DatePickerComponent,
    DatepickerDirective,
    DatepickerVanTotDirective,
    DatePickerSummaryComponent,
    DateVanTotPickerComponent,
    DateVanTotPickerSummaryComponent,
    DecimalComponent,
    DecimalSummaryComponent,
    ErrorContainerComponent,
    FailureComponent,
    FakeContentItemComponent,
    FakeContentSectionComponent,
    IconComponent,
    InfoComponent,
    LabelComponent,
    MobielSchadeMeldenComponent,
    MultiselectComponent,
    MultiselectSummaryComponent,
    MultiUploadComponent,
    MultiUploadSummaryComponent,
    NumberComponent,
    NumberSummaryComponent,
    RadiobuttonListComponent,
    RadiobuttonListComingDaysComponent,
    RadiobuttonListComingDaysSummaryComponent,
    RadiobuttonListRepairComponent,
    RadiobuttonListRepairWithSearchComponent,
    RadiobuttonListSummaryComponent,
    RadiobuttonListWithDescriptionComponent,
    ReferentieComponent,
    RuitherstellerComponent,
    SelectieComponent,
    SelectieSummaryComponent,
    SingleChoiceWithFilterComponent,
    StatusComponent,
    StatusDynamicComponent,
    SuccesComponent,
    SummaryComponent,
    TelefoonComponent,
    TextareaComponent,
    TextareaSummaryComponent,
    TekstregelComponent,
    TekstregelSummaryComponent,
    TimePickerComponent,
    TimePickerSummaryComponent,
    UploadComponent,
    UploadSummaryComponent,
    WoonglasherstellerComponent,
    VraagboomSummaryGroupComponent,
    VraagControlComponent,
    VraagControlSummaryComponent,
    VragenboomComponent,
    SliderComponent,
    SliderSingleComponent,
    SliderSingleSummaryComponent,
    ProgressComponent,
    MultiselectDoorvragenComponent,
    MultilineTextComponent,
    MultiselectDoorvragenSummaryComponent,
    SvgAlertComponent
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    FileDropComponent,
    SanitizeUrlPipe,

    LoaderComponent,
    SharedTekstComponent,
    VerzekeringComponent,
    BedragComponent,
    BedragSummaryComponent,
    ContactComponent,
    ContactGegevensComponent,
    ContactGegevensSummaryComponent,
    DatePickerComponent,
    DatepickerDirective,
    DateDirective,
    DatePickerSummaryComponent,
    DecimalComponent,
    DecimalSummaryComponent,
    ErrorContainerComponent,
    FailureComponent,
    FakeContentItemComponent,
    FakeContentSectionComponent,
    IconComponent,
    InfoComponent,
    LabelComponent,
    MobielSchadeMeldenComponent,
    MultiselectComponent,
    MultiselectSummaryComponent,
    MultiUploadComponent,
    MultiUploadSummaryComponent,
    NumberComponent,
    NumberSummaryComponent,
    RadiobuttonListComponent,
    ButtonSuccesComponent,
    RadiobuttonListComingDaysComponent,
    RadiobuttonListComingDaysSummaryComponent,
    RadiobuttonListRepairComponent,
    RadiobuttonListRepairWithSearchComponent,
    RadiobuttonListSummaryComponent,
    RadiobuttonListWithDescriptionComponent,
    RuitherstellerComponent,
    ReferentieComponent,
    SelectieComponent,
    SelectieSummaryComponent,
    SingleChoiceWithFilterComponent,
    StatusComponent,
    StatusDynamicComponent,
    SuccesComponent,
    SummaryComponent,
    TelefoonComponent,
    TextareaComponent,
    TextareaSummaryComponent,
    TimePickerComponent,
    TimePickerSummaryComponent,
    UploadComponent,
    UploadSummaryComponent,
    WoonglasherstellerComponent,
    VraagboomSummaryGroupComponent,
    VraagControlComponent,
    VraagControlSummaryComponent,
    VragenboomComponent,
    SliderComponent,
    SliderSingleComponent,
    SliderSingleSummaryComponent,
    ProgressComponent,
    MultiselectDoorvragenComponent,
    MultilineTextComponent,
    MultiselectDoorvragenSummaryComponent,
    SvgAlertComponent
  ]
})

export class ComponentsModule {
  static forRoot(): ModuleWithProviders<ComponentsModule> {
    return {
      ngModule: ComponentsModule,
      providers: [
        WindowService,
        ImageService,
        ChatConfigurationService,
        DataService,
        NavigationService,
        RefreshSessionService
      ],
    };
  }
}
